module.exports = __webpack_public_path__ + "static/media/the-good-fight-mobile-2.ed677994.png";